// Dual-panel Reasons slider (vanilla JS) - Dynamic slide handling
(function () {
    function initSlider(section) {
        const leftSlider = section.querySelector('.kroslo-reasons-slider__wrapper--left');
        const rightSlider = section.querySelector('.kroslo-reasons-slider__wrapper--right');
        
        if (!leftSlider && !rightSlider) return;

        let currentSlide = 0;
        let isAnimating = false;

        // Dynamically get slides from both panels
        const leftSlides = leftSlider ? leftSlider.querySelectorAll('.kroslo-reasons-slider__slide') : [];
        const rightSlides = rightSlider ? rightSlider.querySelectorAll('.kroslo-reasons-slider__slide') : [];
        
        // Use the maximum number of slides from either panel
        const totalSlides = Math.max(leftSlides.length, rightSlides.length);
        
        // If no slides found, exit
        if (totalSlides === 0) return;

        const prevBtn = section.querySelector('.kroslo-reasons-slider__nav-btn--prev');
        const nextBtn = section.querySelector('.kroslo-reasons-slider__nav-btn--next');

        function showSlide(index) {
            if (isAnimating || index < 0 || index >= totalSlides) return;
            isAnimating = true;

            // Update left panel immediately
            if (leftSlides.length > 0) {
                leftSlides.forEach(function (slide, i) {
                    if (i < leftSlides.length) {
                        slide.classList.toggle('active', i === index);
                    }
                });
            }

            // Update right panel with 0.2s delay
            if (rightSlides.length > 0) {
                setTimeout(function () {
                    rightSlides.forEach(function (slide, i) {
                        if (i < rightSlides.length) {
                            slide.classList.toggle('active', i === index);
                        }
                    });
                }, 200);
            }

            currentSlide = index;

            // Reset animation lock after transition completes
            setTimeout(function () {
                isAnimating = false;
            }, 800);
        }

        function nextSlide() {
            showSlide((currentSlide + 1) % totalSlides);
        }

        function prevSlide() {
            showSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }

        if (prevBtn) prevBtn.addEventListener('click', function(e) {
            e.preventDefault();
            prevSlide();
        });
        if (nextBtn) nextBtn.addEventListener('click', function(e) {
            e.preventDefault();
            nextSlide();
        });
    }

    // Initialize all slider sections on the page
    function initAllSliders() {
        const sections = document.querySelectorAll('.kroslo-reasons-slider');
        sections.forEach(function(section) {
            initSlider(section);
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSliders);
    } else {
        initAllSliders();
    }
})();
